module.exports = __webpack_public_path__ + "img/cf.d0335e0a.svg";